import type { Router } from "vue-router";

/** 预加载目标路由的懒加载组件 chunk，减少点击菜单后的白屏等待 */
export function prefetchRouteComponent(router: Router, fullPath: string): void {
    const resolved = router.resolve(fullPath);
    const matched = resolved.matched[resolved.matched.length - 1];
    const loader = matched?.components?.default as (() => Promise<unknown>) | undefined;
    if (typeof loader === "function") {
        void loader();
    }
}
